import { useCallback, useEffect, useState } from "react";

const LS_KEY = "reports-v3:sort-order";
const SYNC_EVENT = "reportsV3:sort-order-changed";

const readFromStorage = () => {
  try {
    const stored = localStorage.getItem(LS_KEY);
    return stored === null ? true : stored === "alpha";
  } catch {
    return true;
  }
};

export const useSortAlpha = () => {
  const [sortAlpha, setSortAlpha] = useState(readFromStorage);

  useEffect(() => {
    const sync = () => setSortAlpha(readFromStorage());
    window.addEventListener(SYNC_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(SYNC_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const toggleSortAlpha = useCallback(() => {
    setSortAlpha((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(LS_KEY, next ? "alpha" : "date");
      } catch {}
      window.dispatchEvent(new Event(SYNC_EVENT));
      return next;
    });
  }, []);

  return [sortAlpha, toggleSortAlpha];
};
